import { Injector } from '@angular/core';
var AppModule = /** @class */ (function () {
    function AppModule(injector) {
        AppModule.injector = injector;
    }
    return AppModule;
}());
export { AppModule };
